import { sendRequest } from "../request";
const BASE_URL = '/api/patentApplications';

export function createPatentApplication(data) {
    return sendRequest(`${BASE_URL}/createPatentApplication`, 'POST', data, 'Unable to create patent application');
}

export function getPatentApplications(user) {
    return sendRequest(`${BASE_URL}/getPatentApplications/${user._id}`);
}

export function getClientPatentApplications(user, clientID) {
    return sendRequest(`${BASE_URL}/getClientPatentApplications/${user._id}/${clientID}`);
}

export function updatePatentApplication(applicationID, data) {
    return sendRequest(`${BASE_URL}/updatePatentApplication/${applicationID}`, 'PUT', data, 'Unable to update patent application');
}

export function getPatentApplication(applicationID){
    return sendRequest(`${BASE_URL}/getPatentApplication/${applicationID}`)
}

export function deletePatentApplication(applicationID) {
    return sendRequest(`${BASE_URL}/deletePatentApplication/${applicationID}`, 'DELETE', {}, 'Unable to delete patent application');
}

export function findPatentApplications(user, searchQuery) {
    return sendRequest(`${BASE_URL}/findPatentApplications/${user._id}/${searchQuery}`);
}